<template>
  <qtm-dialog-card
    v-bind="$attrs"
    persistent
    title="Add a New Contact"
    width="450"
    @update:model-value="$emit('update:model-value', $event)"
  >
    <contact-form
      ref="contactForm"
      :contact="contact"
      :vendor="vendor"
      :email-required="emailRequired"
      :vendor-contacts="vendor?.contacts"
    />
    <template v-slot:actions>
      <v-spacer />
      <qtm-btn size="x-large" tertiary @click="$emit('update:model-value', false)">
        Cancel
      </qtm-btn>
      <qtm-btn class="my-3" size="x-large" @click="saveAndClose">
        Add
      </qtm-btn>
    </template>
  </qtm-dialog-card>
</template>

<script setup lang="ts">
import { v4 as uuidv4 } from 'uuid'
import type { Vendor } from '@quotetome/materials-api'
import ContactForm from '@/components/vendors/contact-form.vue'

export interface Props {
  emailRequired?: boolean,
  emitOnly?: boolean,
  vendor?: Vendor,
}
const props = defineProps<Props>()

const emit = defineEmits(['new-contact', 'update:model-value'])

const loading = ref(false)
const contact = ref({
  id: uuidv4(),
  first_name: '',
  last_name: '',
  email: '',
  phone_extension: '',
  phone_number: '',
})

const clean = () => {
  contact.value = {
    id: uuidv4(),
    first_name: '',
    last_name: '',
    email: '',
    phone_extension: '',
    phone_number: '',
  }
}

const { $api, $error, $toast } = useNuxtApp()

const contactFormRef = useTemplateRef('contactForm')
const saveAndClose = async () => {
  if (!contactFormRef.value?.isValid()) {
    $toast.error('Please correct the errors')
    return
  }
  contactFormRef.value?.resetValidation()

  if (props.emitOnly) {
    emit('new-contact', contact.value)
    emit('update:model-value', false)
    clean()

    return
  }

  loading.value = true
  try {
    const payload = {
      ...contact.value,
      id: undefined,
      organization: props.vendor?.id,
    }

    const c = await $api.v1.vendors.addContact(payload)
    emit('new-contact', c)
    emit('update:model-value', false)
    clean()
  }
  catch (error) {
    $error.report(error)
  }
  loading.value = false
}
</script>
